import React from 'react';
import { GUIDANCE } from '../data/mock';
import Reveal from './Reveal';
import { AlertTriangle, ShieldAlert, Hand, Eye, Moon } from 'lucide-react';

const iconFor = (i) => {
  const icons = [Eye, Hand, Moon, ShieldAlert];
  const Icon = icons[i] || AlertTriangle;
  return <Icon className="w-4 h-4" />;
};

const ContentGuidance = () => {
  return (
    <section
      id="guidance"
      className="relative py-20 md:py-28 px-6 md:px-10 border-t border-[#3a2818]/40"
    >
      <div className="max-w-4xl mx-auto">
        <Reveal>
          <div className="flex items-center justify-center gap-3 text-[#c8935a]">
            <AlertTriangle className="w-4 h-4" />
            <p className="text-[10px] tracking-[0.5em] font-fell-sc uppercase">
              {GUIDANCE.heading}
            </p>
            <AlertTriangle className="w-4 h-4" />
          </div>
        </Reveal>

        <Reveal delay={100}>
          <p className="mt-6 font-fell italic text-lg md:text-xl text-[#d9c8a3] text-center max-w-2xl mx-auto leading-relaxed">
            {GUIDANCE.lead}
          </p>
        </Reveal>

        <Reveal delay={200}>
          <div className="mt-6 text-center">
            <span className="inline-block border border-[#c8935a]/50 px-4 py-1.5 text-[10px] tracking-[0.4em] font-fell-sc uppercase text-[#c8935a]">
              {GUIDANCE.age}
            </span>
          </div>
        </Reveal>

        <div className="mt-12 grid sm:grid-cols-2 gap-4">
          {GUIDANCE.triggers.map((t, i) => (
            <Reveal key={t.title} delay={250 + i * 100}>
              <div className="h-full p-5 md:p-6 border border-[#3a2818]/70 bg-[#0d0805]/50 hover:border-[#c8935a]/60 hover:bg-[#140d08]/70 transition-colors duration-500">
                <div className="flex items-center gap-3">
                  <span className="w-8 h-8 rounded-full border border-[#c8935a]/50 flex items-center justify-center text-[#c8935a]">
                    {iconFor(i)}
                  </span>
                  <h3 className="font-display text-base md:text-lg text-[#e8dcc0] tracking-wider">
                    {t.title}
                  </h3>
                </div>
                <p className="mt-3 font-fell text-sm text-[#a89880] leading-relaxed">
                  {t.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={700}>
          <p className="mt-10 pt-6 border-t border-[#3a2818]/50 font-fell italic text-sm text-[#8b7355] text-center max-w-2xl mx-auto leading-relaxed">
            {GUIDANCE.optOut}
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default ContentGuidance;
